import { object, type InferOutput } from "valibot"
import { InputActionTypeSchema } from "./InputActionType"
import { AnyInputBindingSchema } from "./InputBinding/InputBindingUnion.type"

export const ActionBindingSchema = object({
  action: InputActionTypeSchema,
  input: AnyInputBindingSchema,
})

export type ActionBinding = InferOutput<typeof ActionBindingSchema>

